










import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getUserId } from '@/firebaseApp'
import Guests from '@/services/Guests'

@Component
export default class CallWaiter extends Vue {
  @Prop({ required: true }) public calledWaiter!: boolean

  public restaurantId: string = ''
  public accessCode: string = ''
  public timeout: number = 0
  public message = ''

  created() {
    this.restaurantId = this.$route.params.restaurantId
    this.accessCode = this.$route.params.accessCode
  }

  async call(call: boolean) {
    const userId = await getUserId()
    await Guests.callWaiter(this.restaurantId, this.accessCode, userId, call)

    if (call) {
      // @ts-ignore
      const audio = new Audio(require('@/assets/waiteriscalled.mp3'))
      audio.play()
      this.timeout = setTimeout(() => {
        this.message = this.$i18n.t('callWaiter.message') + ''
      }, 10000) // 10 sec
    }
  }

  @Watch('calledWaiter')
  calledWaiterChange() {
    this.message = ''
    clearTimeout(this.timeout)
  }
}
